import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useRecoilState } from 'recoil'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { Button } from '/src/components/common'
import { Loading } from '/src/components/loading'
import { useStores, useCartInventoryAll } from '/src/hooks'
import { getRequest } from '/src/httpClient'
import { userStoreState } from '../storeSelectorState'

import './store_list.scss'

const StoreStockListItem = ({ address, inventory, name, plant_id, store, loading, selectStoreHandler }) => {
  const isActive = store && store.dsap_plant_id === plant_id ? true : false

  return (
    <div className={isActive ? "store-list-item mb-4 pb-4 active" : "store-list-item mb-4 pb-4"}>
      <Row>
        <Col sm={6}>
          <div className="title-container">
            <h5 className="title">
              {name}
              {isActive && (
                <>
                  <span>(Current)</span>
                </>
              )}
            </h5>
          </div>
          {inventory ? <StoreStockListItemIn /> : <StoreStockListItemOut />}
          <Address {...address} />
        </Col>
        <Col sm={6} className="d-flex justify-content-center align-items-center">
          {isActive ? (
            <Button variant="primary" disabled={true}>
              Current Store
            </Button>
          ) : (
            <Button variant="primary" onClick={() => selectStoreHandler(plant_id)}>
              {loading ? 'Loading...' : 'Set Store'}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  )
}

const StoreStockListItemIn = () => {
  return (
    <div className="in-stock stock mt-3 mb-3">
      <FontAwesomeIcon icon={faCircleCheck} />
      <label>In Stock</label>
    </div>
  )
}

const StoreStockListItemOut = () => {
  return (
    <div className="no-stock stock mt-3 mb-3">
      <FontAwesomeIcon icon={faCircleXmark} />
      <label>No Stock</label>
    </div>
  )
}

export const StoreStockList = ({ product_variation_id, quantity, setDisplay }) => {
  const [store, setStore] = useRecoilState(userStoreState)
  const { isLoading, results } = useCartInventoryAll(product_variation_id, quantity)
  const [loading, setLoading] = useState(false)
  const stores = useStores()

  if (isLoading | !results) {
    return <Loading />
  }

  const selectStoreHandler = (id) => {
    setLoading(id)
    getRequest(`/api/store/update?s=${id}`, new AbortController()).then((res) => {
      setStore(stores.find(({ dsap_plant_id }) => dsap_plant_id === id))
      setDisplay(false)
      setLoading(false)
    })
  }

  return (
    <div className="store-list-container">
      <Row>
        {results.map(({ address, inventory, name, plant_id }, index) => {
          return (
            <Col sm={12} key={index}>
              <StoreStockListItem 
                address={address} 
                inventory={inventory} 
                name={name}
                plant_id={plant_id}
                store={store}
                loading={loading === plant_id}
                selectStoreHandler={selectStoreHandler} />
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

// @todo, move to common
const Address = ({ address_line1, administrative_area, locality, postal_code }) => {
  return `${address_line1}, ${locality} ${administrative_area} ${postal_code}`
}